import * as React from 'react';
import { IAny, ICoreContext, IGeneric, IImageSettings } from '@msdyn365-commerce/core';
import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import ProductComponent from '../../../themes/dobbies/views/components/product.component';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';
import { IUnbxdProduct } from '../types/unbxd-product';
import { IProductWithModes } from '../../dobbies-search-result-container/components';

export interface IUnbxdProductCarouselItemProps {
    context: ICoreContext<IGeneric<IAny>>;
    productUrl: string;
    product: IUnbxdProduct;
    position: number;
    typeName: string;
    showAddToBasket?: boolean;
    removeProduct?: () => void;
    showRemoveProductButton?: boolean;
    removedProductFromCart?: number | null;
    onClickAndCollect: (product: IProductWithModes, setExistsInCartLines: React.Dispatch<React.SetStateAction<boolean>>) => void;
}
export const UnbxdProductCarouselItem: React.FC<IUnbxdProductCarouselItemProps> = ({
    context,
    product,
    typeName,
    showAddToBasket,
    removeProduct,
    showRemoveProductButton,
    onClickAndCollect,
    removedProductFromCart
}) => {
    const imageUrl = product.imageUrl?.length
        ? product.imageUrl[0]
        : generateImageUrl(product.PrimaryImageUrl, context.request.apiSettings);
    const nonClubPlusDiscount = {
        BasePrice: product.AdjustedPrice,
        AdjustedPrice: product.AdjustedPrice,
        CustomerContextualPrice: product.CustomerContextualPrice
    };

    // @ts-ignore
    const isOnlyStoreAttr = product.AttributeValues?.find((attr: AttributeValue) => attr.Name === 'OnlyInStore');
    const isOnlyStore = isOnlyStoreAttr ? isOnlyStoreAttr.TextValue : '';
    const defaultImageSettings: IImageSettings = {
        viewports: {
            xs: { q: 'w=300&h=422&m=6', w: 300, h: 422 },
            lg: { q: 'w=300&h=422&m=6', w: 300, h: 422 },
            xl: { q: 'w=300&h=422&m=6', w: 300, h: 422 }
        },
        lazyload: true
    };
    return (
        <div className='msc-product'>
            <ProductComponent
                context={context}
                imageSettings={defaultImageSettings}
                id={product.RecordId?.toString() || ''}
                typeName={typeName}
                data={{ product: { ...product, ItemId: product.uniqueId, PrimaryImageUrl: imageUrl } }}
                nonClubPlusDiscount={nonClubPlusDiscount}
                showDeliveryIcons={false}
                isUnbxdWidget={true}
                isOnlyStore={isOnlyStore && isOnlyStore === 'Yes' ? true : false}
                showUnbxdAddToBasket={showAddToBasket}
                isProductAvailable={product.IsProductAvailable}
                onClickAndCollect={onClickAndCollect}
                showRemoveProductButton={showRemoveProductButton}
                onRemoveProduct={removeProduct}
                removedProductFromCart={removedProductFromCart}
            />
        </div>
    );
};

export default UnbxdProductCarouselItem;
